// WARNING: These constants must be manually synced with the backend.
// When adding/removing/changing codes, update both:
//   - This file (frontend)
//   - src/BLogic.Moone.Domain/App/Models/AccessRightCodes.cs (backend)
export const AccessRightCodes = {
  Dashboard: "Dashboard",
  SystemControl: "SystemControl",
  Users: "Users",
  IDDocuments: "IDDocuments",
  Merchants: "Merchants",
  Hunters: "Hunters",
  Licenses: "Licenses",
  Employees: "Employees",
  Campaigns: "Campaigns",
  Notifications: "Notifications",
  Stardust: "Stardust",
  Valor: "Valor",
  Transactions: "Transactions",
  Banking: "Banking",
  Permissions: "Permissions",
  Paypoints: "Paypoints",
  Settlements: "Settlements",
  Parties: "Parties",
  Verifications: "Verifications",
  IDVerifications: "IDVerifications",
  BankVerifications: "BankVerifications",
  RiskProfileVerifications: "RiskProfileVerifications",
  AdditionalVerifications: "AdditionalVerifications",
  Facilities: "Facilities",
  AppProducts: "AppProducts",
  Earnings: "Earnings",
  Stories: "Stories",
  Chat: "Chat",
  Marketplace: "Marketplace",
  HunterPrerequisites: "HunterPrerequisites",
  FailedTransactions: "FailedTransactions",
  Coupons: "Coupons",
  TerminalInventory: "TerminalInventory",
  Raffle: "Raffle",
} as const;

export type AccessRightCode = keyof typeof AccessRightCodes;
